import { path_relative_to_absolute } from '@/utils/utils_files_client';

export async function FN_IMAGE__download(url_relative: string, name: string) {
  let url = path_relative_to_absolute(url_relative);

  // Fetch the image as a blob
  const response = await fetch(url);
  const blob = await response.blob();

  // Create object URL from blob
  const url_blob = window.URL.createObjectURL(blob);

  // Create temporary anchor element
  const link = document.createElement('a');
  link.href = url_blob;

  link.download = name + '.webp';

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  window.URL.revokeObjectURL(url_blob);
}
